import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBwUIRwfe-luWZAaMukOYeHz5Xix4lkXsY",
  authDomain: "firestore-5ffcf.firebaseapp.com",
  projectId: "firestore-5ffcf",
  storageBucket: "firestore-5ffcf.appspot.com",
  messagingSenderId: "557747986005",
  appId: "1:557747986005:web:cc0bd74346da5a433a3edc",
  measurementId: "G-NR4F5H87XM"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

var auth = firebase.auth();
var provider = new firebase.auth.GoogleAuthProvider();
var database = firebase.firestore();

export { auth, provider, database };
